<template>
		<div style="background-color:#F5F5F5;width:100%;height:100%;">
			<!-- 主文 -->
			<div style="display: flex;justify-content: center;align-items: center;">
					<div style="background-color:white;display: flex;">
						<div style="width: 590px;height:695px;padding-left: 20px;">
							<div class="zxls">招贤纳士</div>
							<div style="padding:5px 0 5px;margin-bottom:10px;">
								<div style="font-size:14px;text-align:left;"></div>
								<div style="display:flex;flex-wrap: wrap;">
									<div v-for="(item,index) in sb" :key="index" style="display: flex;">
										<div class="kes fontcolor">{{item.a}}</div>
										<div v-if="(index!=0&&index!=6)" class="Lines"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="background-color:white;display: flex;margin-left:10px;">
						<div style="width: 590px;height:695px;padding-left: 20px;">
							<div class="zxls">招贤纳士</div>
							<div style="padding:5px 0 5px;margin-bottom:10px;">
								<div style="font-size:14px;text-align:left;"></div>
								<div style="display:flex;flex-wrap: wrap;">
									<div v-for="(item,index) in sb" :key="index" style="display: flex;">
										<div class="kes fontcolor">{{item.a}}</div>
										<div v-if="(index!=0&&index!=6)" class="Lines"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
			</div>
		</div>
</template>

<script>
	export default {
		name:"product",
		components:{
		},
		data() {
			return {
				tabIndex:7,
				tabIndexs:0,
				mok:[
					{
						a:'最新培训',
						b:'LATEST TRAINING'
					},
					{
						a:'线上活动',
						b:'ONLINE ACTIVITIES'
					},
					{
						a:'需求发布',
						b:'DEMAND RELEASE'
					},
					{
						a:'园区展示1',
						b:'LATEST TRAINING'
					},
					{
						a:'园区展示2',
						b:'LATEST TRAINING'
					},
					{
						a:'园区展示3',
						b:'LATEST TRAINING'
					},
					{
						a:'园区展示4',
						b:'LATEST TRAINING'
					},
					{
						a:'园区展示5',
						b:'LATEST TRAINING'
					},
					{
						a:'园区展示6',
						b:'LATEST TRAINING'
					},
				],
				dh:[
					{a:'首页'},
					{a:'活动'},
					{a:'研究'},
					{a:'学院'},
					{a:'人物视界'},
					{a:'融资并购'},
					{a:'转移转化'},
				],
				zx:[
					{a:'资讯'},
					{a:'政策'},
					{a:'会议'},
					{a:'人物'},
					{a:'投资'},
					{a:'分析'},
					{a:'供需'},
				],
				ks:[
					{a:'心血管'},
					{a:'骨科'},
					{a:'肿瘤'},
					{a:'神外'},
					{a:'影像'},
					{a:'眼科'},
					{a:'口腔'},
					{a:'急诊'},
					{a:'ICU'}
				],
				gz:[
					{a:'骨科植入'},
					{a:'血管介入'},
					{a:'神经外科'},
					{a:'眼科'},
					{a:'口腔科'},
					{a:'3D打印'},
				],
				sb:[
					{a:'物理诊断器'},
					{a:'影响类'},
					{a:'分析仪器'},
				],
				dxb:[
					{a:'物理诊断器asd111111111'},
					{a:'影响类2222222'},
					{a:'分析仪器3333333'},
					{a:'电生理类44444444'},
				],
				dxbs:[
					{a:'物理诊断器asd111111111'},
					{a:'影响类2222222'},
					{a:'分析仪器3333333'},
				],
				// 轮播图
				indicatorDots: true,
				autoplay: true,
				interval: 2000,
				duration: 500
			}
		},
		onLoad() {

		},
		methods: {
			change:function(e){
				console.log(e);
				this.tabIndex=e
				switch(e){
					case 0:
						this.$router.push({name:'Home'});
						break;
					case 1:
						this.$router.push({name:'modify'});
						break;
					case 2:
						this.$router.push({name:'Research'});
						break;
					case 3:
						this.$router.push({name:'college'});
						break;
					case 4:
						this.$router.push({name:'character'});
						break;
					case 5:
						this.$router.push({name:'Resource'});
						break;
					case 6:
						this.$router.push({name:'recommendation'});
						break;	 				
				 }
				  this.$store.commit("navbgshow",e)
				
		},
		changes:function(e){
				this.tabIndexs=e
		},
		},
	}
</script>

<style lang="scss" scoped>
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		font-weight:bold;
		color:#181818;
		font-size:16px;
		margin-top: 10px;
	}
</style>
